export interface CostCenterClass {
    AccountCostCenterId: number
    AccountCostCenterCode: string
    AccountCostCenter: string
    AccountId: number
    CreatedOn: Date | undefined
    CreatedByEmployeeId: number
    ModifiedOn: Date | undefined
    ModifiedByEmployeeId: number
    IsDisabled: boolean
    MasterCostCenterId: number
    SortOrder: number
    AccountCostCenterGuidId: string
    isSelected: number
}

export const costCenterInitialsForAdd = {
    AccountCostCenterCode: "",
    AccountCostCenter: "",
    SortOrder: "",
    IsDisabled: false
}

export const costCenterInitialsForUpdate = {
    AccountCostCenterCode: "",
    AccountCostCenter: "",
    SortOrder: "",
    AccountCostCenterId: "",
    IsDisabled: false
}